<template>
  <label :class="{ 'is-active': active }" class="BigCheckbox flex items-center" @click="toggle">
    <span class="BigCheckbox_radio fa-layers fa-2x">
      <i class="fal fa-square unchecked"></i>
      <i class="fal fa-check-square checked"></i>
    </span>

    <span v-if="label" class="ml-2 font-normal">
      {{ label }}
    </span>
  </label>
</template>

<script>
export default {
  name: "BigCheckbox",
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      default: null,
    },
  },
  methods: {
    toggle() {
      this.$emit("change", !this.active)
    },
  },
}
</script>

<style scoped>
.BigCheckbox {
  @apply my-2 cursor-pointer;
}

.BigCheckbox .checked {
  visibility: hidden;
}

.BigCheckbox.is-active span.BigCheckbox_radio {
  @apply text-primary;
}

.BigCheckbox.is-active .checked {
  visibility: visible;
}

.BigCheckbox.is-active .unchecked {
  visibility: hidden;
}
</style>
